import MenuItem from './MenuItem';
import {store} from "@/plugins/vuex";

class MenuService {
  /**
   * @type MenuItem[]
   */
  menuItems = [];

  addMenuItem(menuItem) {
    if (!(menuItem instanceof MenuItem)){
      throw new Error("addMenuItem accepts MenuItem class instance only")
    }
    this.menuItems.push(menuItem);
  }

  filterMenuItems(items, excludedPaths) {
    return items
      .filter(item => !excludedPaths.includes(item.path))
      .map(item => {
        if (item.children && item.children.length > 0) {
          // If the current item has children, recursively filter those as well
          item = {
            ...item,
            children: this.filterMenuItems(item.children, excludedPaths)
          };
        }
        return item;
      });
  };

  getItems() {
    const excludedPaths = store.state.global.excludeSideBarColumns;
    if (store.state.global.batchUnsoldParams && !store.state.global.batchUnsoldParams.enable_dpv) {
      excludedPaths.push('/dpv');
    }
    const filteredMenuItems = this.filterMenuItems(this.menuItems, excludedPaths);
    return filteredMenuItems.sort((a, b) => a.weight - b.weight);
  }
}


export default new MenuService();
